const MODULE_NAME = "LOGIN_CANDIDATES";
const CLEAR = MODULE_NAME + "FETCH_STARTED";
const FETCH_STARTED = MODULE_NAME + "FETCH_STARTED";
const FETCH_COMPLETED = MODULE_NAME + "FETCH_COMPLETED";

export {
  CLEAR,
  FETCH_STARTED,
  FETCH_COMPLETED
};
